/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Represents the importance level a company assigns to a matching algorithm feature.
 * @export
 */
export const FeatureImportance = {
    NotImportant: 'NotImportant',
    Average: 'Average',
    Important: 'Important'
};
export function instanceOfFeatureImportance(value) {
    for (const key in FeatureImportance) {
        if (Object.prototype.hasOwnProperty.call(FeatureImportance, key)) {
            if (FeatureImportance[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FeatureImportanceFromJSON(json) {
    return FeatureImportanceFromJSONTyped(json, false);
}
export function FeatureImportanceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FeatureImportanceToJSON(value) {
    return value;
}
export function FeatureImportanceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
